import React, { useMemo, useState } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { CrmContactEntity } from '../../../../../../api/types/crm/contacts/crm-contact-entity';
import { AddCrmContactDialog } from './components/add-crm-contact-dialog';

interface AccountContactsProps {
  accountId: number | null;
  contacts: CrmContactEntity[];
  loading: boolean;
  onRefresh: () => void;
}

const optionalTextCell = (value: string | null | undefined) => {
  if (value === null || value === undefined) return 'חסר';
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : 'ריק';
};

export const AccountContacts: React.FC<AccountContactsProps> = ({
  accountId,
  contacts,
  loading,
  onRefresh,
}) => {
  const [showAddDialog, setShowAddDialog] = useState<boolean>(false);

  const sortedContacts = useMemo(() => {
    const copy = [...(contacts ?? [])];
    copy.sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary));
    return copy;
  }, [contacts]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ fontSize: '1.1rem', fontWeight: 700 }}>אנשי קשר</div>
        <Button
          label="הוספת איש קשר"
          icon="pi pi-plus"
          onClick={() => setShowAddDialog(true)}
          disabled={!accountId}
        />
      </div>

      <DataTable
        value={sortedContacts}
        loading={loading}
        dataKey="id"
        emptyMessage={
          <div style={{ textAlign: 'right' }}>לא נמצאו אנשי קשר</div>
        }
        style={{ direction: 'rtl' }}
      >
        <Column
          field="isPrimary"
          header="ראשי"
          style={{ width: '90px', textAlign: 'right' }}
          body={(row: CrmContactEntity) => (row.isPrimary ? 'כן' : 'לא')}
        />
        <Column
          header="שם"
          style={{ textAlign: 'right' }}
          body={(row: CrmContactEntity) =>
            `${row.firstName ?? ''} ${row.lastName ?? ''}`.trim() || 'חסר'
          }
        />
        <Column
          field="idNumber"
          header="ת.ז"
          style={{ textAlign: 'right' }}
          body={(row: CrmContactEntity) => optionalTextCell(row.idNumber)}
        />
        <Column
          field="phone"
          header="טלפון"
          style={{ textAlign: 'right' }}
          body={(row: CrmContactEntity) => optionalTextCell(row.phone)}
        />
        <Column
          field="email"
          header="אימייל"
          style={{ textAlign: 'right' }}
          body={(row: CrmContactEntity) => optionalTextCell(row.email)}
        />
        <Column
          field="address"
          header="כתובת"
          style={{ textAlign: 'right' }}
          body={(row: CrmContactEntity) => optionalTextCell(row.address)}
        />
        <Column
          field="notes"
          header="הערות"
          style={{ textAlign: 'right' }}
          body={(row: CrmContactEntity) => optionalTextCell(row.notes)}
        />
      </DataTable>

      <AddCrmContactDialog
        visible={showAddDialog}
        accountId={accountId}
        onHide={() => setShowAddDialog(false)}
        onSuccess={onRefresh}
      />
    </div>
  );
};
